export interface FolderArray {
  name: string;
  uuid: string;
}

const getFolderArrayByUrl = (urlParams: string): FolderArray[] => {
  const result = urlParams.split('/').map(section => {
    const parts = section.split('-');
    const uuid = parts.pop();
    const name = parts.join(' ');

    return {
      name: name,
      uuid: uuid as string,
    };
  });

  return result;
};

export default getFolderArrayByUrl;
